import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface SiteInfo {
  site_name: string
  created_on: string
  description: string
  image: string
}

export interface SiteInfoState {
  isLoading: boolean
  loadingError: string | null
  siteInfo: SiteInfo | null
  httpStatus: number | null
}

export const initialState: SiteInfoState = {
  isLoading: true,
  loadingError: null,
  siteInfo: null,
  httpStatus: null
}

const siteInfoSlice = createSlice({
  name: 'assetManagementSiteInfo',
  initialState,
  reducers: {
    siteInfoLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        siteInfo: null,
        httpStatus: 0
      }
    },
    siteInfoUpdateAction: (state, action: PayloadAction<{ data: SiteInfo, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        siteInfo: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    siteInfoErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        siteInfo: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  siteInfoLoadingAction,
  siteInfoUpdateAction,
  siteInfoErrorAction
} = siteInfoSlice.actions

export default siteInfoSlice.reducer
